import React from 'react';
import { Link } from 'react-router-dom';
import { Heading } from 'elements';
import momentDate from 'utils/momentDate';
import tulkojumi from 'utils/tulkojumi';
import { StyledItem, StyledHeading, TagsList } from './styled';

class RezultatsItem extends React.PureComponent {
    _renderTerms = (terms, key) => (
        terms[key] && (
            <li key={key}>
            {
                terms[key]
                .map(i => i.name)
                .join(', ')
            }
            </li>
        )
    );

    render() {
        const {
            postType,
            termsArray,
            lang,
            path,
            title,
            date_created,
            date_modified,
            terms,
            acf,
            teksti,
        } = this.props;

        let acfData;
        try {
          acfData = acf && JSON.parse(acf);
        } catch (error) { }

        let tagsList;
        if (postType === 'dokumenti') {
          let pubDate = acfData.publicets;
          pubDate = pubDate && momentDate(pubDate, lang, true);
          tagsList = [
            <li key='date'>{pubDate ? pubDate : ''}</li>,
            this._renderTerms(terms, 'dokumenti_departimenti'),
            this._renderTerms(terms, 'dokumenti_veidi')
          ];

        } else if (postType === 'iepirkumi') {
          let pubDate = acfData.publicesanas_datums;
          pubDate = pubDate && momentDate(pubDate, lang, true);

          let iesnDate = acfData.iesnieguma_termins;
          iesnDate = iesnDate && momentDate(iesnDate, lang, true);

          tagsList = [
            <li key='publicesanas_datums'>
              { pubDate ? `${tulkojumi(teksti, 'publicets')}: ${pubDate}` : '' }
            </li>,
            <li key='iesnieguma_termins'>
              {iesnDate ? `${tulkojumi(teksti, 'iesniegsanai')}: ${iesnDate}` : '' }
            </li>,
            this._renderTerms(terms, 'iepirkumi_statuss'),
          ];
          } else if (postType === 'nodoklu_zinojumi') {

          let pubDate = acfData.publicets;
          pubDate = pubDate && momentDate(pubDate, lang, true);

          let izdotsDate = acfData.izdots;
          izdotsDate = izdotsDate && momentDate(izdotsDate, lang, true);

          tagsList = termsArray.map(
            term => this._renderTerms(terms, term)
          );
        
        } else if (postType === 'jaunumi') {
          let date = date_created;
          date = momentDate(date, lang, true);
          tagsList = [
            <li key='date'>{date}</li>,
            ...termsArray.map(
              term => this._renderTerms(terms, term)
            ),
          ];

        } else {
          tagsList = termsArray.map(
            term => this._renderTerms(terms, term)
          );
        }

        return (
            <StyledItem>
                <Link to={path}>
                    <StyledHeading>
                        {title}
                    </StyledHeading>
                    <TagsList>
                        {tagsList}
                    </TagsList>
                </Link>
            </StyledItem>
        );
    }
}

export default RezultatsItem;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/RezultatsItem/RezultatsItem.jsx